module.exports = {
  header: {
    Learnmore:'更多',
    Email:'电邮',
    Telno:'电话',
    Contact:'联系我们',
    XiAn:"西安",
    HongKong:"香港",
    Shanghai:'上海',
    banq:'版权所有 © 2021 万钧航空动力科技(中国)有限公司·保留所有权利.',
    Name:'名称',
    Email1:'邮箱',
    Phone:'联系电话',
    Remark:'备注',
    Learn:'阅读更多 >',
    Details:'详细信息',
    close:'关闭',
    send:'发送',
  },
}



// WEBPACK FOOTER //
// ./src/lang/zh.js